import { createSlice } from '@reduxjs/toolkit';
import { ACTION_TYPES } from '@views/AdminPanelView/components/AdminPanel/components/LinkInBio/components/MyPages/components/ActiveButtonModal/utils/constants.js';

export const ActiveButtonContextInitialsValues = {
  actionCTA: {},
  id: 0,
  elementGroup: '',
  elementType: '',
  elementId: 0,
  targetElementGroup: '',
  targetElementType: '',
  targetElementId: 0,
  actionTypeDefault: ACTION_TYPES.urlLink,
  actionType: '',
  actionValue: '',
  text: 'Website',
  backgroundColor: '#ffffff',
  textColor: '#000000',
  position: '',
  margin: 0,
  icon: 'none',
  border: 'none',
  borderColor: '#000000',
  shadow: 'soft',
  shadowColor: '#000000',
  shape: 'square',
  opacity: 0,
};

const initialState = {
  isLoading: false,
  isActive: false,
  id: 0,
  uid: 0,
  sid: 0,

  blockContent: {
    content: '',
    contentPosition: '',
    contentTrimCount: 30,
    isContentTrim: false,

    headingLabels: [],

    title: '',
    titleAlign: 'left',
    titleLineHeight: 120,
    titleSize: 22,
    isHighlightTitle: false,
    titleBackgroundColor: '#000000',
    titleColor: '#ffffff',

    image: '',
    imagePosition: '',

    isSectionMinHeight: false,
    sectionMinHeight: 100,

    titlePositionN: 1,
    contentPositionN: 2,
    imagePositionN: 3,
    buttonPositionN: 4,
  },
  containerDesign: {},
};

export const textSlice = createSlice({
  name: 'text',
  initialState,
  reducers: {
    textStore: (state, action) => {
      const payload = action.payload ?? {};
      const { id, isActive, sid, uid, data } = payload;

      const block = data ?? {};
      const blockContent = block.blockContent ?? {};
      const containerDesign = block.blockDesign?.containerDesign ?? {};

      state.isLoading = false;
      state.id = id ?? 0;
      state.isActive = isActive;
      state.sid = sid;
      state.uid = uid;

      state.containerDesign = containerDesign ?? {};
      state.blockContent = {
        content: blockContent.content ?? '',
        contentPosition: blockContent.contentPosition ?? '',
        contentTrimCount: blockContent.contentTrimCount ?? 30,
        isContentTrim: blockContent.isContentTrim ?? false,

        headingLabels: blockContent.headingLabels ?? [],

        title: blockContent.title ?? '',
        titleAlign: blockContent.titleAlign ?? 'left',
        titleLineHeight: blockContent.titleLineHeight ?? 120,
        titleSize: blockContent.titleSize ?? 22,
        isHighlightTitle: blockContent.isHighlightTitle ?? false,
        titleBackgroundColor: blockContent.titleBackgroundColor ?? '#000000',
        titleColor: blockContent.titleColor ?? '#ffffff',

        image: blockContent?.image ?? '',
        imagePosition: blockContent?.imagePosition ?? '',

        isSectionMinHeight: blockContent.isSectionMinHeight ?? false,
        sectionMinHeight: blockContent.sectionMinHeight ?? 100,

        currentCtaId: blockContent.currentCtaId ?? 0,

        buttonLayout: blockContent.buttonLayout ?? 'vertical',

        titlePositionN: blockContent.titlePositionN ?? 1,
        contentPositionN: blockContent.contentPositionN ?? 2,
        imagePositionN: blockContent.imagePositionN ?? 3,
        buttonPositionN: blockContent.buttonPositionN ?? 4,
      };
    },
    textClear: () => initialState,

    textUpdateIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    textUpdateIsActive: (state, action) => {
      state.isActive = action.payload;
    },
    textUpdateBlockContent: (state, action) => {
      state.blockContent = action.payload;
    },

    textChangeCurrentCtaId: (state, action) => {
      state.blockContent.currentCtaId = action.payload;
    },
  },
});

export const { textUpdateIsLoading, textStore, textClear, textUpdateIsActive, textUpdateBlockContent, textChangeCurrentCtaId } = textSlice.actions;

export const selectTextIsLoading = (state) => state.text.isLoading;

export const selectTextIsActive = (state) => state.text.isActive;
export const selectTextId = (state) => state.text.id;
export const selectTextUID = (state) => state.text.uid;
export const selectTextSID = (state) => state.text.sid;

export const selectTextContainerDesign = (state) => state.text.containerDesign;
export const selectTextBlockContent = (state) => state.text.blockContent;

export default textSlice.reducer;
